import { Controller } from '@hotwired/stimulus';
import axios from 'axios';
import { compact, debounce, isEmpty } from 'lodash';
import { createCifraVueApp } from '..';

// Tiempo de espera entre que el usuario deja de editar y se llama a guardar borrador
const DELAY_GUARDAR_BORRADOR = 1000;

/* global $ */
export default class extends Controller {
  connect() {
    this.modificado = false;
    this.guardandoBorrador = false;
    this.labelModificado = this.element.querySelector('#label-modificado');
    this.form = this.element.querySelector('form');
    this.inputMensajeId = this.form.querySelector('#mensaje_id');
    this.botonEnviar = this.element.querySelector('.btn-enviar');
    this.botonDescartar = this.element.querySelector('.btn-discard');
    if (isEmpty(this.inputMensajeId.value)) {
      this.botonDescartar.style.display = 'none';
    }
    this.#cargarDropzoneVue();
    this.#cargarSummernote();
    this.#controlSubmit();

    this.#controlModificaciones();
  }

  #cargarDropzoneVue() {
    const dropzone = this.element.querySelector('dropzone');
    // No existe cuando le dan a volver o para atrás y luego adelante en el navegador
    if (!dropzone) {
      return;
    }
    const wrapper = this.element.querySelector('dropzone').parentElement;
    const app = createCifraVueApp();
    app.mount(wrapper);
    this.#gestionarBloqueoAlAdjuntar(wrapper);
  }

  // Gestión de bloqueo del botón si adjuntan un fichero. Cuando añaden un adjunto
  // se bloquea y cuando termina de subirse se desbloquea
  #gestionarBloqueoAlAdjuntar(wrapper) {
    const dropzone = wrapper.querySelector('.dropzone-cifra');
    this.ficherosAnadidos = 0;
    this.ficherosTerminados = 0;

    dropzone.addEventListener('addedfile', () => {
      this.ficherosAnadidos += 1;
      if (this.ficherosAnadidos > this.ficherosTerminados) {
        this.botonEnviar.disabled = true;
      }
    });
    dropzone.addEventListener('complete', () => {
      this.ficherosTerminados += 1;
      if (this.ficherosTerminados >= this.ficherosAnadidos) {
        this.botonEnviar.disabled = false;
        // Guardamos para que se asocie el adjunto con el borrador.
        // Esto si da si se guarda borrador, luego se adjunta y luego se sale.
        // El borrador se guardaría con su id pero el adjunto se queda en sesión
        this.#guardarBorrador();
      }
    });
  }

  // Tenemos que inicializar en el evento 'summernote:loaded' porque summernote
  // ni siquiera se registra como componente cifra por eso no podemos usar los eventos del store
  #cargarSummernote() {
    this.$summernote = $('[data-provider="summernote"]');

    this.$summernote.on('summernote:loaded', () => {
      this.$summernote.summernote('focus');
      this.$summernote.on('summernote.change', (_we, contents) => {
        $('#mensaje_texto').val(contents);
      });
    });
  }

  #controlSubmit() {
    this.form.addEventListener('submit', (event) => {
      const mensajeTexto = $('#mensaje_texto');
      mensajeTexto.val(mensajeTexto.summernote('code'));
      if (this.guardandoBorrador) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      return true;
    });
  }

  #guardarBorrador(_options = {}) {
    const data = {
      mensaje: {
        id: this.inputMensajeId.value,
        asunto: this.form.querySelector('#mensaje_asunto').value,
        texto: this.$summernote.summernote('code'),
        reply_to: this.form.querySelector('#mensaje_reply_to')?.value,
      },
      destinatario_usuario_ids: compact(
        this.form.querySelector("input[name='destinatario_usuario_ids']").value.split(','),
      ),
      destinatario_mensajeria_direccion_ids: compact(
        this.form.querySelector("input[name='destinatario_mensajeria_direccion_ids']").value.split(','),
      ),
    };

    return axios.post('/mensajes/save_borrador', data).then((response) => {
      this.inputMensajeId.value = response.data.mensaje.id;
      this.#activarBotonDescartar(response.data.mensaje.id);
    });
  }

  #activarBotonDescartar(idMensaje) {
    this.botonDescartar.setAttribute('href', `/mensajes/${idMensaje}/discard`);
    this.botonDescartar.style.display = 'block';
  }

  #setModificado(modificado) {
    if (modificado) {
      this.labelModificado.classList.remove('hide');
    } else {
      this.labelModificado.classList.add('hide');
    }
    this.botonEnviar.disabled = modificado;
    this.modificado = modificado;
  }

  // Nos conectamos a los eventos de todos los campos para que si se modifican se
  // vaya guardando el borrador
  #controlModificaciones() {
    let onModificado;

    const debounceGuardarBorrador = debounce(() => {
      if (this.guardandoBorrador) {
        // Para que cuando termine vuleva a llamarse para que se guarden los cambios
        this.necesitaRellamar = true;
        return;
      }
      this.guardandoBorrador = true;
      this.#guardarBorrador().then(() => {
        this.#setModificado(false);
        if (this.necesitaRellamar) {
          this.necesitaRellamar = false;
          onModificado();
        }
        this.guardandoBorrador = false;
      }).catch(() => {
        this.guardandoBorrador = false;
      });
    }, DELAY_GUARDAR_BORRADOR);

    onModificado = () => {
      this.#setModificado(true);
      debounceGuardarBorrador();
    };

    this.form.querySelectorAll('#mensaje_asunto').forEach((input) => {
      input.addEventListener('keyup', onModificado);
    });

    this.form.querySelectorAll('#mensaje_remitente, #contenedor-destinatarios').forEach((input) => {
      input.addEventListener('change', onModificado);
    });

    $('[data-provider="summernote"]').on('summernote.change', onModificado);
  }
}
